// The sales agent whose link brought a company here: a lead's sign-up link (/vendor?ref=<agent>&lead=<lead>,
// copied from Admin → Leads) is kept in this browser for 30 days, so the application sent later — after a
// look around, a sign-in, another visit — still names them (vendor-submissions apply, salesRef).
const KEY = "aldoo-sales-ref"
const KEEP_MS = 30 * 24 * 60 * 60 * 1000
const isId = (v) => /^[0-9a-f]{24}$/i.test(String(v || ""))

/** Reads ?ref / ?lead off the address, when there, and keeps them. */
export function keepSalesRef() {
  if (typeof window === "undefined") return
  const params = new URLSearchParams(window.location.search)
  const agentId = params.get("ref"), leadId = params.get("lead")
  if (!isId(agentId) && !isId(leadId)) return
  try {
    localStorage.setItem(KEY, JSON.stringify({ agentId: isId(agentId) ? agentId : "", leadId: isId(leadId) ? leadId : "", at: Date.now() }))
  } catch {
    // no storage (a private window): the application goes without it
  }
}

/** { agentId, leadId } kept within the last 30 days, or undefined. */
export function salesRef() {
  try {
    const kept = JSON.parse(localStorage.getItem(KEY) || "null")
    if (!kept || Date.now() - (kept.at || 0) > KEEP_MS) return undefined
    return { agentId: kept.agentId || "", leadId: kept.leadId || "" }
  } catch {
    return undefined
  }
}
